import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/lib/shadcn/ui/dialog";
import { Button } from "@/lib/shadcn/ui/button";
import { Input } from "@/lib/shadcn/ui/input";
import { Label } from "@/lib/shadcn/ui/label";
import { errorPopup } from "@/utils/alerts";
import { ApartmentOwner } from "@/models/responses";

interface AddOwnerModalProps {
    open: boolean;
    onClose: () => void;
    onSubmit: (fullName: string, taxisUsername: string, taxisPassword: string, taxId: string) => void;
    existingOwner?: ApartmentOwner;
}

const AddOwnerDialog: React.FC<AddOwnerModalProps> = ({ open, onClose, onSubmit, existingOwner }) => {
    const [fullName, setFullName] = useState<string>(existingOwner?.fullName || "");
    const [taxisUsername, setTaxisUsername] = useState<string>(existingOwner?.taxisUserName || "");
    const [taxisPassword, setTaxisPassword] = useState<string>(existingOwner?.taxisPassword || "");
    const [taxId, setTaxId] = useState<string>(existingOwner?.taxId || "");

    useEffect(() => {
        setFullName(existingOwner?.fullName || "");
        setTaxisUsername(existingOwner?.taxisUserName || "");
        setTaxisPassword(existingOwner?.taxisPassword || "");
    }, [existingOwner]);

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        try {
            onSubmit(fullName, taxisUsername, taxisPassword, taxId);
            handleClose();
        } catch (error) {
            errorPopup(`Failed to ${existingOwner ? "update" : "add"} owner: ${error}`);
        }
    };

    const handleClose = () => {
        setFullName("");
        setTaxisUsername("");
        setTaxisPassword("");
        setTaxId("");
        onClose();
    };

    return (
        <Dialog open={open} onOpenChange={handleClose}>
            <DialogContent className="sm:max-w-[600px]">
                <DialogHeader>
                    <DialogTitle>{existingOwner ? "Edit" : "Add"} Owner</DialogTitle>
                </DialogHeader>

                <form onSubmit={handleSubmit} className="space-y-6">
                    <div className="grid grid-cols-2 gap-4">
                        <div className="space-y-2">
                            <Label htmlFor="fullName">Name</Label>
                            <Input id="fullName" type="text" value={fullName} onChange={(e) => setFullName(e.target.value)} required />
                        </div>
                        <div className="space-y-2">
                            <Label htmlFor="taxId">Tax Id</Label>
                            <Input id="taxId" type="text" value={taxId} onChange={(e) => setTaxId(e.target.value)} />
                        </div>
                        <div className="space-y-2">
                            <Label htmlFor="taxisUsername">Taxis Username</Label>
                            <Input
                                id="taxisUsername"
                                type="text"
                                value={taxisUsername}
                                onChange={(e) => setTaxisUsername(e.target.value)}
                            />
                        </div>
                        <div className="space-y-2">
                            <Label htmlFor="taxisPassword">Taxis Password</Label>
                            <Input
                                id="taxisPassword"
                                type="text"
                                value={taxisPassword}
                                onChange={(e) => setTaxisPassword(e.target.value)}
                            />
                        </div>
                    </div>

                    <DialogFooter>
                        <Button type="button" variant="outline" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button type="submit">{existingOwner ? "Update" : "Add"}</Button>
                    </DialogFooter>
                </form>
            </DialogContent>
        </Dialog>
    );
};

export default AddOwnerDialog;
